<template>
    <div class="results-container">
        <div class="results-header">
            <h4>Report Results</h4>
            <span class="results-count">{{ reportData.length }} records found</span>
        </div>
        <CustomTable
            class="report-table"
            :scrollable="true"
            bordered
        >
            <template #head>
                <tr>
                    <th v-for="column of columns" :key="column.key">
                        {{ column.title }}
                    </th>
                </tr>
            </template>
            <template #body>
                <tr v-for="reportItem of reportData" :key="reportItem.id">
                    <td v-for="column of columns" :key="reportItem.id + '' + column.key">
                        <div v-if="column.renderHtml" v-html="sanitizeHtml(reportItem[column.key])"></div>
                        <a
                            v-else-if="column.linkKey"
                            target="_blank"
                            rel="noopener noreferrer"
                            :href="safeHref(reportItem[column.linkKey])"
                            class="table-link"
                        >
                            {{ reportItem[column.key] }}
                        </a>
                        <span v-else>{{ column.prefix || "" }}{{ reportItem[column.key] }}</span>
                    </td>
                </tr>
            </template>
        </CustomTable>

        <div class="pagination-container">
            <Paginator @change="$emit('page-change', $event)" :page="page" :totalPages="totalPages" />
        </div>
    </div>
</template>

<script>
import CustomTable from "../layout/CustomTable.vue"
import Paginator from "../other/Paginator.vue"
import { sanitizeHtml } from "../../utils/sanitize-html"

export default {
    name: "ReportResultsTable",
    components: {
        CustomTable,
        Paginator,
    },
    props: {
        reportData: {
            type: Array,
            default: () => [],
        },
        columns: {
            type: Array,
            default: () => [],
        },
        page: {
            type: Number,
            default: 1,
        },
        totalPages: {
            type: Number,
            default: 0,
        },
    },
    methods: {
        sanitizeHtml,
        safeHref(value) {
            const href = `${value || ""}`.trim()
            if (!href) return "#"
            if (href.startsWith("/") && !href.startsWith("//")) return href
            try {
                const url = new URL(href)
                return ["http:", "https:"].includes(url.protocol) ? href : "#"
            } catch (error) {
                return "#"
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

.results-container {
    background: $lightCardBg;
    border-radius: 16px;
    border: 1px solid $lightBorderColor;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.results-header {
    padding: 20px 28px;
    background: $lightCardBg;
    border-bottom: 1px solid $lightBorderColor;
    display: flex;
    align-items: center;
    justify-content: space-between;

    h4 {
        color: $primaryColor;
        font-size: 18px;
        font-weight: 600;
        margin: 0;
    }

    .results-count {
        color: rgba($textColor, 0.7);
        font-size: 14px;
        font-weight: 500;
    }
}

.report-table {
    font-size: 14px;

    .table-link {
        color: $primaryColor;
        text-decoration: none;
        font-weight: 500;

        &:hover {
            color: $secondaryColor;
            text-decoration: underline;
        }
    }
}

.pagination-container {
    padding: 20px 28px;
    background: $lightCardBg;
    border-top: 1px solid $lightBorderColor;
}
</style>
